<div class="container">
  <mat-checkbox
    [checked]="allItemsSelected"
    [indeterminate]="indeterminate"
    (change)="onAllCheckboxStateChange($event)">
  </mat-checkbox>

  @if (shareAvailable) {
    <button mat-icon-button
      [disabled]="!hasSelectedItems"
      (click)="clickShare.emit()"
      [matTooltip]="'share' | transloco">
      <mat-icon>share</mat-icon>
    </button>
  }

  @if (shareOffAvailable) {
    <button mat-icon-button
      [disabled]="!hasSelectedItems"
      (click)="clickShareOff.emit()"
      [matTooltip]="'share_off' | transloco">
      <mat-icon>share_off</mat-icon>
    </button>
  }

  @if (showAvailable) {
    <button mat-icon-button
      [disabled]="!hasSelectedItems || disableShow"
      (click)="clickShow.emit()"
      [matTooltip]="'show_overlay' | transloco">
      <mat-icon>visibility</mat-icon>
    </button>
  }

  @if (hideAvailable) {
    <button mat-icon-button
      [disabled]="!hasSelectedItems || disableHide"
      (click)="clickHide.emit()"
      [matTooltip]="'hide_overlay' | transloco">
      <mat-icon>visibility_off</mat-icon>
    </button>
  }

  <span class="spacer"></span>

  @if (moreAvailable && moreMenu) {
    <button
      mat-icon-button
      [disabled]="!hasSelectedItems"
      [matTooltip]="'more' | transloco"
      [matMenuTriggerFor]="moreMenu">
      <mat-icon>more_horiz</mat-icon>
    </button>
  }
</div>
